import {
  AggregateNode,
  AggregateSchema
} from 'types/transformation/types/nodes'

import { getColumnName, getNextColumnSuffix } from '../utils'
import DataType from 'types/transformation/enums/DataType'

export const FUNCTIONS: { name: string; id: AggregateSchema['function'] }[] = [
  { name: 'Första', id: 'first' },
  { name: 'Summa', id: 'sum' },
  { name: 'Min', id: 'min' },
  { name: 'Max', id: 'max' }
]

// Mirrors Spark: min/max/first keep the input type, sum gives BIGINT/DOUBLE
export const getOutputType = (
  func: AggregateSchema['function'],
  inputType: DataType
): DataType => {
  if (func !== 'sum') {
    return inputType
  }

  return inputType === DataType.BIGINT ? DataType.BIGINT : DataType.DOUBLE
}

export const getNewColumn = (node: AggregateNode): AggregateSchema => {
  const suffix = getNextColumnSuffix(node.schema)

  return {
    id: getColumnName(node.id, `aggregate_${suffix}`),
    name: '',
    reference_node: node.id,
    reference_node_index: node.index,
    left_column: null,
    function: 'sum',
    type: DataType.DOUBLE
  }
}
